import qs from 'qs'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

import { removeEmpty } from 'utils'


export const getRiskLevelDashboard = async (req) => {
    const params = removeEmpty(req)
    const config = {
        method: 'get',
        url: '/api/v1/dashboard/risk_level',
        params: params,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        },
    }
  try {
    const {data, status} = await defaultInstance.request(config)
    if(status !== 200) {
        return responseError({ message: 'API something went wrong' })
    }
    return responseSuccess({data: [...data.data]});
     
  } catch (err) {
    if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
  }
}
